import { ExportOutlined } from '@ant-design/icons';
import { clsx } from 'clsx';
import React from 'react';

export interface ExternalLinkProps {
  href: string;
  children: React.ReactNode;
  className?: string;
  showIcon?: boolean;
  iconClassName?: string;
}

export const ExternalLink: React.FC<ExternalLinkProps> = ({
  href,
  children,
  className,
  showIcon = true,
  iconClassName,
}) => {
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className={clsx(
        'text-bleu-hellio hover:underline inline-flex items-center gap-1 font-bold',
        className,
      )}
    >
      {children}
      {showIcon && (
        <ExportOutlined className={clsx('text-xs', iconClassName)} />
      )}
    </a>
  );
};
